import { render, staticRenderFns } from "./ViewDetailConjugation.vue?vue&type=template&id=7dc4e482&scoped=true&"
import script from "./ViewDetailConjugation.vue?vue&type=script&lang=js&"
export * from "./ViewDetailConjugation.vue?vue&type=script&lang=js&"
import style0 from "./ViewDetailConjugation.vue?vue&type=style&index=0&id=7dc4e482&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc4e482",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VRow,VSimpleTable})
